export const environment = {
  production: true,
  apiUrl : 'https://api.nitwallet.io'

};
